import React from 'react'

import MContainer from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'

const Container = ({ children }) => (
  <MContainer maxWidth="lg">
    <Box py={4}>{children}</Box>
  </MContainer>
)

export default Container
